import React, { Component } from 'react';

export default class Placeholder extends Component {
  render() {
    const { children } = this.props;
    return <div className="placeholder">{children}</div>
  }
}